import { updateProposal } from 'actions/team_assist_v2/lib/team_assist_v2_answer';
import TeamAssistV2Turn from 'models/team_assist_v2_turn';

/** The `tool_use` block holding the proposal `toolUseId` names, in any of the turn's answers, or null. */
export function findProposalBlock(turn, toolUseId) {
  const answers = [turn.answer, ...turn.followUps].filter(Boolean);
  for (const answer of answers) {
    const block = answer.blocks.find(b => b.toolUseId === toolUseId && b.proposal);
    if (block) {
      return block;
    }
  }
  return null;
}

/** The turn with `fn` applied to the proposal `toolUseId` names, wherever it sits. */
export function turnWithProposal(turn, toolUseId, fn) {
  return {
    ...turn,
    answer: turn.answer && updateProposal(turn.answer, toolUseId, fn),
    followUps: turn.followUps.map(answer => updateProposal(answer, toolUseId, fn)),
  };
}

/** Applies `fn` to the proposal `toolUseId` names in the stored turn, if the store still holds it. */
export function writeProposal(store, turnId, toolUseId, fn) {
  if (!store.has({ id: turnId })) {
    return;
  }
  store.addOrReplace(TeamAssistV2Turn.create(turnWithProposal(store.find(turnId).toJs(), toolUseId, fn)));
}
